import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import IButtonComponent from '../iComponents/iButton/IButton';
import { descargarExcelDesdeJSON } from '../../../helpers/generatePackingList';
import { getPackingListgCommodity } from '../../../store/actions';
import Iloading from '../iComponents/iLoading/Iloading';

const PackingList = ({ CommodityList, groupName }: any) => {
  const dispatch = useDispatch();
  const [showLoading, setShowLoading] = useState(true);
  const [dataList, setDataList] = useState<any>([]);  
  const { packingList, isLoadingPackingList } = useSelector(
    (state: any) => state.Commodity,
  );
  console.log('IS... LOADING...', isLoadingPackingList);
  console.log('SHO LOADING...', showLoading);

  useEffect(() => {
    setShowLoading(true);
    if (!CommodityList?.GUID) return;
    setDataList([]);
    dispatch(getPackingListgCommodity({ GUID: CommodityList.GUID, groupName }));
  }, [CommodityList?.GUID, groupName, dispatch]);

  useEffect(() => {
    let timer: string | number | NodeJS.Timeout | undefined;
    if (packingList && packingList.comodityData.length > 0 && isLoadingPackingList == false) {
      console.log('..... USEFECT... ', packingList.comodityData.length);
      setDataList(packingList);
      timer = setTimeout(() => {
        setShowLoading(false);
      }, 400);
      return () => clearTimeout(timer);
    } else {
      setShowLoading(true);
    }
  }, [packingList]);


  const DownloadPackingList = () => {
    descargarExcelDesdeJSON(dataList, groupName);
  };
  return (
    <div>
      <Iloading loading={isLoadingPackingList == true} />
      {dataList ? (
        <IButtonComponent
          actionOnClick={DownloadPackingList}
          className="btn-search"
          label={ (showLoading == false  && isLoadingPackingList == false) ? 'Packing List': 'Cargando...' }
          btnIcon="bx bx-down-arrow-alt"
          disabled={ !(showLoading == false  && isLoadingPackingList == false) }
        />
      ) : null}
    </div>
  );
};

export default PackingList;